import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { BookOpen, Clock, Package, Droplets, Flame, Scale, ChefHat } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { formatGiacenza } from "../../utils/udmUtils";

export const VisualizzaRicettaDialog = ({ open, onOpenChange, item, isAdmin, getCategoriaNome, formatTempo, onVerifica }) => {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto rounded-3xl bg-card border-border">
        <DialogHeader>
          <DialogTitle className="text-foreground flex items-center gap-2">
            <BookOpen className="h-5 w-5 text-purple-500" />
            {item?.nome}
          </DialogTitle>
        </DialogHeader>

        {item && (
          <div className="space-y-6">
            <div className="flex flex-wrap gap-3">
              <span className="text-sm px-3 py-1 bg-muted rounded-full text-foreground">{getCategoriaNome(item.categoria_id)}</span>
              {item.tempo_preparazione && (
                <span className="text-sm px-3 py-1 bg-blue-500/10 rounded-full text-blue-400 flex items-center gap-1">
                  <Clock className="h-4 w-4" />{formatTempo(item.tempo_preparazione)}
                </span>
              )}
            </div>

            <div className="space-y-3">
              <h3 className="text-foreground font-semibold flex items-center gap-2">
                <Package className="h-4 w-4 text-primary" />Ingredienti ({item.ingredienti?.length || 0})
              </h3>
              <div className="space-y-2">
                {item.ingredienti?.map((ing, idx) => (
                  <div key={idx} className="flex items-center gap-3 p-3 bg-muted/50 rounded-xl">
                    <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center text-xs text-primary font-medium">{idx + 1}</div>
                    <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${ing.is_acqua ? 'bg-blue-500/20' : 'bg-lime-400/20'}`}>
                      {ing.is_acqua ? <Droplets className="h-4 w-4 text-blue-400" /> : <Package className="h-4 w-4 text-lime-400" />}
                    </div>
                    <div className="flex-1">
                      <p className="text-foreground font-medium">{ing.ingrediente_nome}</p>
                      <p className="text-muted-foreground text-sm">
                        {formatGiacenza(ing.quantita, ing.is_acqua ? "ml" : ing.unita_misura)}
                        {ing.cotto && <span className="text-orange-400 ml-2"><Flame className="h-3 w-3 inline" /> calo -{ing.calo_cottura_percentuale}%</span>}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {item.note && (
              <div className="space-y-2">
                <h3 className="text-foreground font-semibold">Note</h3>
                <p className="text-muted-foreground bg-muted/50 p-3 rounded-xl">{item.note}</p>
              </div>
            )}

            <div className="p-4 bg-muted/30 rounded-xl border border-border">
              <div className="flex items-center gap-2 mb-2"><Scale className="h-5 w-5 text-muted-foreground" /><span className="text-foreground font-medium">Peso Finale</span></div>
              <p className="text-foreground font-bold text-xl text-center">{item.peso_finale_grammi || Math.round((item.peso_finale_kg || 0) * 1000)}g</p>
            </div>
          </div>
        )}

        <DialogFooter className="pt-4 gap-2">
          {item && !item.verificata && (
            <Button onClick={() => { onOpenChange(false); onVerifica(item); }} className="flex-1 bg-amber-500 hover:bg-amber-600 text-white font-bold" data-testid="verifica-from-view-btn">
              <Scale className="h-4 w-4 mr-2" />Verifica peso e tempo
            </Button>
          )}
          {!isAdmin && item?.richiede_tracciabilita && (
            <Button onClick={() => { onOpenChange(false); navigate(`/lotti?ricetta_id=${item.id}`); }} className="flex-1 bg-purple-500 hover:bg-purple-600 text-white font-bold" data-testid="prepara-from-view-btn">
              <ChefHat className="h-4 w-4 mr-2" />Prepara
            </Button>
          )}
          <Button onClick={() => onOpenChange(false)} className={`${(!isAdmin && item?.richiede_tracciabilita) || (item && !item.verificata) ? 'flex-1' : 'w-full'} bg-primary hover:bg-primary/90 text-white font-bold`}>Chiudi</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
